<template lang="pug">
.view-platforms.content
  ui-navbar-panel(title="Статистика платформ")
    b-button.mr-10(type="is-warning", icon-left="refresh", @click="updateAllPlatformInfo") Обновить

  div.columns
    div.column
      b-table(
        :data="mappedPlatforms",
        :loading="platforms.$state.loading",
        detail-key="id",
        default-sort="name",
        detailed,
        striped
      )
        //- Row
        b-table-column(field="id", label="ID", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.id }}

        b-table-column(field="name", label="Название", sortable v-slot="{row}")
          | {{ row.name }}

        b-table-column(field="infoUsersActive", label="Активных", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoUsersActive }}

        b-table-column(field="infoUsersWorking", label="Работающих", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoUsersWorking }}

        b-table-column(field="infoUsersOnline", label="Онлайн ", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoUsersOnline }}

        b-table-column(field="infoObjectsTotal", label="Объектов", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoObjectsTotal }}

        b-table-column(field="infoObjectsClinics", label="Клиник", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoObjectsClinics }}

        b-table-column(field="infoObjectsDrugstore", label="Аптек", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoObjectsDrugstore }}

        b-table-column(field="infoFilesTotal", label="Файлов", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoFilesTotal }}

        b-table-column(field="infoTreatiesTotal", label="Договора: всего", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoTreatiesTotal }}

        b-table-column(field="infoTreatiesActual", label="Договора: актуальные", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoTreatiesActual }}

        b-table-column(field="infoCustomFieldsTotal", label="Настр. Поля", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.infoCustomFieldsTotal }}

        //- Details
        template(slot="detail", slot-scope="{row}")
          .mb-10
            b-tooltip.mr-10(label="Актуальность данных"): b-tag.is-primary {{ row.updated_at | dateFormat('dd MMMM yyyy - HH:mm:ss') }}
            b-tooltip.mr-10(label="Адрес платформы"): a.tag.is-info(:href="`https://${row.host}`", target="_blank")
              span {{ row.host }}
              b-icon(icon="arrow-top-right-thick", size="is-small")

          platform-info(:info="row.info")

</template>

<script>
import Platform from '@/models/Platform';

export default {
  name: 'view-stat',

  data: () => ({
    platforms: Platform.collection(),
  }),

  computed: {
    mappedPlatforms() {
      return this.platforms.items.map(item => {
        return {
          ...item,
          infoUsersActive: item.getInfoValue('users', 'active') || 0,
          infoUsersWorking: item.getInfoValue('users', 'working') || 0,
          infoUsersOnline: item.getInfoValue('users', 'online') || 0,
          infoObjectsTotal: item.getInfoValue('objects', 'total') || 0,
          infoObjectsClinics: item.getInfoValue('objects', 'object-clinics') || 0,
          infoObjectsDrugstore: item.getInfoValue('objects', 'object-drugstore') || 0,
          infoFilesTotal: item.getInfoValue('files', 'total') || 0,
          infoTreatiesTotal: item.getInfoValue('treaties', 'total') || 0,
          infoTreatiesActual: item.getInfoValue('treaties', 'actual') || 0,
          infoCustomFieldsTotal: item.getInfoValue('custom-fields', 'total') || 0,
        };
      });
    },
  },

  methods: {
    loadPlatforms() {
      this.platforms.$fetch({
        include: 'label',
        filter: { status: 'eq:1' },
        scope: '',
      });
    },

    // updatePlatformInfo(platform) {
    //   platform.$pullPlatformStat();
    // },

    updateAllPlatformInfo() {
      this.platforms.items.forEach(platform => {
        platform.$pullPlatformStat();
      });
    },
  },

  created() {
    this.loadPlatforms();
  },
};
</script>
